module.exports = __webpack_public_path__ + "static/media/fjøs.a47ca5d6.m4a";